<template>
    <cta
        is-link
        class="top"
        size="L"
        font-icon="fn_angleUp"
        type="text"
        :content="config.ctas.top"
        @click="scrollToTop"
    />
</template>

<script>
import Cta from 'gvue/src/core/Cta'
import scroll from '@/helpers/scroll'

export default {
    name: 'ButtonTop',
    components: { Cta },
    computed: {
        config() {
            return this.$json.config
        }
    },
    methods: {
        scrollToTop() {
            scroll().toTop()
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables

.g
    .top
        margin-top: ($gap * 2)
        margin-bottom: 0

        ::v-deep
            span
                padding-right: $gap

            [class*="Up"]
                &::before
                    top: 50%
                    font-size: 1.5em
</style>
